<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Gadi Bhade Report</h2>
        </div>
        <div class="card">
       <!-- Plot Name Filter -->
<div class="select2-container">
    <select class="form-input" id="plot_name" ref="plotName" v-model="sale.plotid" >
        <option value=""></option>
        <option value="All">All</option>
        <option v-for="(item, index) in plotList" :key="item.id" :value="item.id">{{ item.name }}</option>
    </select>
</div>

<!-- Employee Name Filter -->
<div class="select2-container">
    <select class="form-input" id="cust_name" ref="employeeName" v-model="sale.custid" >
        <option value=""></option>
        <option value="All">All</option>
        <option v-for="(item, index) in employeeList" :key="item.id" :value="item.id">{{ item.name + ' ' + item.contact }}</option>
    </select>
</div>

<!-- Product Name Filter -->
<div class="select2-container">
    <select class="form-input" id="prd_name" ref="productName" v-model="prd.prdid" >
        <option value=""></option>
        <option value="All">All</option>
        <option v-for="(item, index) in productsList" :key="item.id" :value="item.id">{{ item.name }}</option>
    </select>
</div>
        </div>


        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Name</th>
                                    <th class="bg-[#B2E8D9]">Contact</th>
                                    <th class="bg-[#B2E8D9]">Salary</th>
                                    <th class="bg-[#B2E8D9]">gender</th>
                                    <th class="bg-[#B2E8D9]">Branch Name</th>
                                    <th class="bg-[#B2E8D9]">Plot Name</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <!-- Show "No records available" if no filtered results -->
                                <tr v-if="filteredSaleList.length === 0">
                                    <td colspan="6" class="text-center">No records available</td>
                                </tr>
                                
                                <!-- Loop through filteredSaleList -->
                                <tr v-for="(item, index) in filteredSaleList" :key="item.id">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.contact }}</td>
                                    <!-- <td @click="filterCustomer(item.custid)">{{ item.cust_name }}</td> -->
                                    <td>{{ item.salary }}</td>
                                    <td>{{ item.gender }}</td>
                                    <td>{{ item.branch_name }}</td>
                                    <td>{{ item.plot_name }}</td>

                                    <!-- <td>
                                        <div class="flex items-center gap-1">
                                            <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.id)">
                                                <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                            </button> 
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'SaleList',
components: {
 
} ,
mounted(){    
 this.getBasics();
 this.getBasicsData();
 $(this.$refs.plotName).select2({
            placeholder: 'Select Plot',
            allowClear: true
        });

        $(this.$refs.employeeName).select2({
            placeholder: 'Select Employee',
            allowClear: true
        });

        $(this.$refs.productName).select2({
            placeholder: 'Select Product',
            allowClear: true
        });
},
data() {
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     sale: {
            plotid: null,
            custid: null
        },
        prd: {
            prdid: null
        },
     saleList:[],
     filteredSaleList: [],
     plotList: [], // plot options
        employeeList: [], // employee options
        productsList: [],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 }, 
 computed: {
    filteredSaleList() {
        return this.saleList.filter((item) => {
            return (
                (!this.sale.plotid || this.sale.plotid === item.plotid) && 
                (!this.sale.custid || this.sale.custid === item.custid) && 
                (!this.prd.prdid || this.prd.prdid === item.prdid)   
            );
        });
    }
},
methods:{
    onFilterChange() {
            // Handle filter change logic
        },
    async getBasicsData() {
          var self=this;
            axios.post('getSalesBasic').then(function (response) {
                    self.productsList=response.data.products;
                    self.employeeList=response.data.employees; 
                    self.plotList=response.data.plots; 
                    self.employees=response.data.userDetails;
               
                    console.log(self.batchnos);
                   }).then(()=>{
                                 self.prd_select_tag= $("#prd_name").select2({
                                    width: '100%',
                                    dropdownAutoWidth : true,
                                    placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a ref='add_product' class='  btn-primary-icon-light size-7'>Add Product</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                  }).on('change', function (event) {
                                        self.selectedProduct = self.productsList.find(item => item.id === event.target.value);
                                        self.prd={...self.selectedProduct};
                                        self.prd.prdid=self.selectedProduct.id;
                                        self.batchnos=self.prd.batchlist;
                                        // self.prd.manufacturingdate = self.batchnos[0].mfgDate.split(' ')[0]; 
                                        // self.prd.expirydate = self.batchnos[0].expiryDate.split(' ')[0];     

                                        // self.getTotal();
                                        // setTimeout(() => { self.$refs.batch_no.focus();}, 200)
                                        // self.$refs.qty.focus();
                                    });  

                                    $("#cust_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        var selected_customer = self.employeeList.find(item => item.id === event.target.value);
                                            self.sale.custid=selected_customer.id;
                                            self.sale.custcell=selected_customer.contact;
                                            self.sale.custaddress=selected_customer.address;
                                            self.sale.balance=selected_customer.balance;
                                             
                                            // self.prd_select_tag.select2('open');
                                        });  

                                        $("#plot_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Plot Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        var selected_plot = self.plotList.find(item => item.id === event.target.value);
                                            self.sale.plotid=selected_plot.id;
                                            self.sale.custcell=selected_plot.cell;
                                            self.sale.custgst=selected_plot.gst;
                                            self.sale.custaddress=selected_plot.address;
                                            self.sale.balance=selected_plot.balance;
                                             
                                            // self.prd_select_tag.select2('open');
                                        }); 
                        });
     },

 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

    print_invoice(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/thermalPrint?q='+id, '_blank'); 
        },
 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getgadibhade').then(function (response) {
                 self.saleList=response.data.saleList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 
 async filterCustomer(custid) {
       var self=this;
         axios.post('getCustomerSales',{custid:custid}).then(function (response) {
                 self.saleList=response.data.saleList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
                   // $(".datatable").DataTable().destroy();
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 
            delete_category() {
                var self = this; 
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.saleList=response.data.products;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
